import { SignedAngle as t } from "../utils/index32.js";
import { Vectors as e } from "../utils/index36.js";
import { V3toVector3 as m } from "./index9.js";
const c = (o, r = e.Right) => (o = m(o), t(r, o));
export {
  c as dir2Rad
};
//# sourceMappingURL=index5.js.map
